
// TODO: NewsListに置き換え
export default {
  name: 'NewsLists',
  props: {
    lists: {
      type: Array
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const formatDate = (date: string) => {
      const dt = new Date(date)
      const year = dt.getFullYear()
      const month = dt.getMonth() + 1
      const day = dt.getDate()

      return `${year}年${month}月${day}日`
    }

    return {
      formatDate
    }
  }
}
